import { useInboxEntriesStore } from '../../store';

export const useActiveInboxEntriesSlice = () => {
  return useInboxEntriesStore((state) => state.taskManager.activeTaskGroup);
};
